var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mx-2",attrs:{"fab":"","x-small":"","color":_vm.color},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(_vm._s(_vm.mdiHeart))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }